export default {
    LOAD_TASK(state, task) {
        state.items = task;
    }
}